import CircularProgress from "@/components/progress/circular-progress"
import { Button } from "@/components/ui/button"
import { X as XIcon } from "lucide-react"
import { useNavigate } from "react-router-dom"

interface CheckpointModalProps {
  showCheckpointModal: boolean
  onClick: () => void
  confidenceLevels: number[]
  availableCardsQuantity: number
  totalAmountOfCards: number
}

const CheckpointModal = ({
  showCheckpointModal,
  onClick,
  confidenceLevels,
  availableCardsQuantity,
  totalAmountOfCards,
}: CheckpointModalProps) => {
  const navigate = useNavigate()

  const handleOnClose = () => {
    navigate("/flashcards")
  }

  const sumOfAllDeckCards = confidenceLevels.reduce(
    (acc, confidenceLevel) => acc + confidenceLevel,
    0,
  )
  const confidenceLevel = (sumOfAllDeckCards / (totalAmountOfCards * 5)) * 100

  return showCheckpointModal ? (
    <div className="fixed left-0 top-0 z-20 size-full overflow-hidden bg-white">
      <div className="flex w-full shrink-0 items-center justify-between p-5">
        <div className="mx-auto w-full text-center">Checkpoint</div>

        <button type="button" className="shrink-0 text-gray-500" onClick={handleOnClose}>
          <XIcon />
        </button>
      </div>

      <div className="flex size-full flex-col items-center justify-center gap-1 pb-[200px] md:h-auto md:justify-start md:pb-14 md:pt-10">
        <p className="text-center text-lg font-semibold">Índice de confianza actual</p>
        <div className="flex h-auto max-h-[300px] w-full max-w-[300px] overflow-hidden">
          <CircularProgress progress={Math.trunc(confidenceLevel)} className="h-full w-full" />
        </div>
      </div>

      <div className="fixed bottom-0 left-0 z-10 mx-auto w-full max-w-[800px] bg-white p-4 md:static md:p-3 md:text-center">
        <Button
          className="w-full rounded-[8px] bg-orange-500 p-3 text-[14px] font-bold text-white transition duration-200 hover:bg-orange-600 disabled:bg-neutral-200 disabled:text-neutral-500 md:max-w-[300px]"
          onClick={onClick}
        >
          {availableCardsQuantity !== 0
            ? `¿${availableCardsQuantity} ${availableCardsQuantity === 1 ? "carta" : "cartas"} más?`
            : "Terminar"}
        </Button>
      </div>
    </div>
  ) : null
}

export default CheckpointModal
